var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsterisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1C6.5 0.723858 6.27614 0.5 6 0.5C5.72386 0.5 5.5 0.723858 5.5 1H6.5ZM5.5 11C5.5 11.2761 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.2761 6.5 11H5.5ZM5.5 1V11H6.5V1H5.5Z",
    fill: "#551D98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81803 2.11092C2.62277 1.91566 2.30619 1.91566 2.11092 2.11092C1.91566 2.30619 1.91566 2.62277 2.11092 2.81803L2.81803 2.11092ZM9.18199 9.8891C9.37725 10.0844 9.69384 10.0844 9.8891 9.8891C10.0844 9.69384 10.0844 9.37725 9.8891 9.18199L9.18199 9.8891ZM2.11092 2.81803L9.18199 9.8891L9.8891 9.18199L2.81803 2.11092L2.11092 2.81803Z",
    fill: "#551D98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5C0.723858 5.5 0.5 5.72386 0.5 6C0.5 6.27614 0.723858 6.5 1 6.5L1 5.5ZM11 6.5C11.2761 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.2761 5.5 11 5.5L11 6.5ZM1 6.5L11 6.5L11 5.5L1 5.5L1 6.5Z",
    fill: "#551D98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11092 9.18197C1.91566 9.37723 1.91566 9.69381 2.11092 9.88908C2.30619 10.0843 2.62277 10.0843 2.81803 9.88908L2.11092 9.18197ZM9.8891 2.81801C10.0844 2.62275 10.0844 2.30616 9.8891 2.1109C9.69384 1.91564 9.37725 1.91564 9.18199 2.1109L9.8891 2.81801ZM2.81803 9.88908L9.8891 2.81801L9.18199 2.1109L2.11092 9.18197L2.81803 9.88908Z",
    fill: "#551D98"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.f255d06a.svg";
export { ForwardRef as ReactComponent };